import {DependencyList, useCallback, useMemo} from 'react';

function idSelector<T>(c: T): string {
    return c['id'];
}

export function useSet<T>(content: T[], selector: (c: T) => string = idSelector, deps: DependencyList = []) {
    const predicate = useCallback(selector, deps);
    return useMemo(() => {
        return content.reduce<{ [key: string]: T }>(
            (p, c) => ({[predicate(c)]: c, ...p}),
            {},
        );
    }, [content, predicate]);
}
